import { useState } from "react";
import { useNavigate } from "react-router-dom";
import WizardSteps from "./components/WizardSteps";
import Step1Bilgiler from "./components/Step1Bilgiler";
import Step2HedefKitle from "./components/Step2HedefKitle";
import Step3Mesaj from "./components/Step3Mesaj";
import Step4Onizle from "./components/Step4Onizle";

interface WizardData {
  ad: string;
  tip: string;
  aciklama: string;
  baslamaTarihi: string;
  bitisTarihi: string;
  dahiliNot: string;
  hedefKitle: string;
  mesaj: string;
}

export default function YeniKampanyaPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [successMsg, setSuccessMsg] = useState("");
  const [data, setData] = useState<WizardData>({
    ad: "",
    tip: "",
    aciklama: "",
    baslamaTarihi: "",
    bitisTarihi: "",
    dahiliNot: "",
    hedefKitle: "",
    mesaj: "",
  });

  const updateData = (partial: Partial<WizardData>) => {
    setData((prev) => ({ ...prev, ...partial }));
  };

  const canNext = () => {
    if (step === 1) return data.ad.trim() && data.tip;
    if (step === 2) return !!data.hedefKitle;
    if (step === 3) return data.mesaj.trim().length > 0;
    return true;
  };

  const handleBaslat = () => {
    setSuccessMsg("aktif");
    setTimeout(() => navigate("/kampanyalar"), 2000);
  };

  const handleTaslak = () => {
    setSuccessMsg("taslak");
    setTimeout(() => navigate("/kampanyalar"), 2000);
  };

  if (successMsg) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto bg-[#25D366]/10 rounded-full flex items-center justify-center mb-4">
            <div className="w-8 h-8 flex items-center justify-center text-[#25D366]">
              <i className="ri-checkbox-circle-line text-4xl"></i>
            </div>
          </div>
          <h3 className="text-lg font-bold text-gray-900 mb-2">
            {successMsg === "aktif" ? "Kampanya Başlatıldı!" : "Taslak Kaydedildi!"}
          </h3>
          <p className="text-sm text-gray-500">
            {successMsg === "aktif"
              ? "Mesajlar sırayla gönderilmeye başlanacak. Yönlendiriliyorsunuz..."
              : "Kampanya taslak olarak kaydedildi. Yönlendiriliyorsunuz..."}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 xl:p-8 max-w-[1600px]">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => navigate("/kampanyalar")}
          className="w-9 h-9 flex items-center justify-center rounded-xl border border-gray-200 text-gray-500 hover:bg-gray-50 cursor-pointer transition-colors"
        >
          <i className="ri-arrow-left-line text-base"></i>
        </button>
        <div>
          <h2 className="text-xl font-bold text-gray-900">Yeni Kampanya Oluştur</h2>
          <p className="text-sm text-gray-500 mt-0.5">4 adımda kampanyanızı hazırlayın</p>
        </div>
      </div>

      {/* Wizard card */}
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden max-w-4xl">
        {/* Steps indicator */}
        <div className="px-6 pt-6 pb-5 border-b border-gray-100">
          <WizardSteps currentStep={step} />
        </div>

        {/* Step content */}
        <div className="p-6">
          {step === 1 && (
            <Step1Bilgiler
              data={data}
              onChange={updateData}
            />
          )}
          {step === 2 && (
            <Step2HedefKitle
              selected={data.hedefKitle}
              onChange={(val) => updateData({ hedefKitle: val })}
            />
          )}
          {step === 3 && (
            <Step3Mesaj
              mesaj={data.mesaj}
              onChange={(val) => updateData({ mesaj: val })}
            />
          )}
          {step === 4 && (
            <Step4Onizle
              data={data}
              onTaslak={handleTaslak}
              onBaslat={handleBaslat}
              onGeri={() => setStep(3)}
            />
          )}
        </div>

        {/* Navigation buttons (only steps 1-3) */}
        {step < 4 && (
          <div className="px-6 pb-6 flex items-center justify-between border-t border-gray-100 pt-4">
            <button
              onClick={() => step > 1 ? setStep(step - 1) : navigate("/kampanyalar")}
              className="px-4 py-2.5 text-sm border border-gray-200 text-gray-600 rounded-xl hover:bg-gray-50 cursor-pointer whitespace-nowrap transition-colors flex items-center gap-2"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line text-sm"></i>
              </div>
              {step === 1 ? "İptal" : "Geri"}
            </button>
            <button
              onClick={() => setStep(step + 1)}
              disabled={!canNext()}
              className={`px-6 py-2.5 text-sm rounded-xl whitespace-nowrap font-semibold transition-all flex items-center gap-2 cursor-pointer
                ${canNext()
                  ? "bg-[#0B1120] text-white hover:bg-[#1a2a4a]"
                  : "bg-gray-100 text-gray-400 cursor-not-allowed"}
              `}
            >
              İleri
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}